module.exports = __webpack_public_path__ + "static/media/financial_img.72d2fbf8.png";